import styled from 'styled-components';
import { Button, IconTag } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemeColors } from '@tryhackme/thm-ui-components/dist/config/theme/theme.types';

export const StyledAccessDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 3.2rem 1.8rem;
  gap: 1.6rem;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 4.6rem 3.2rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 4.6rem;
  }
`;

export const StyledAccessDetailsTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const StyledAccessDetailsTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.text.light};
  line-height: 3rem;
`;

export const StyledButton = styled(Button)`
  border-color: ${({ theme }) => theme.colors.grey[300]};
  max-width: fit-content;

  > svg {
    width: 1.6rem;
    height: 1.6rem;
  }
`;

export const StyledDescriptionListItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const StyledDescriptionListItemsSingleRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: row;
    gap: 3.2rem;
  }

  > div {
    width: 100%;
  }
`;

export const StyledCircleIcon = styled(FontAwesomeIcon)<{
  $color?: keyof Pick<ThemeColors, 'error' | 'success' | 'warning' | 'info'>;
}>`
  color: ${({ theme, $color }) => ($color ? theme.colors[$color].main : theme.colors.paragraph)};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
`;

export const StyledIconTag = styled(IconTag)`
  margin-top: 0.2rem;
  height: 3.2rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.small};
`;
